(function () {
  'use strict';
  if (typeof THREE === 'undefined') { console.warn('Three.js not loaded'); return; }
  const FW = 70, FL = 105;
  const MARGIN = 8;
  const ROWS = 20;
  const ROW_H = 0.65, ROW_D = 1.4;
  const CROWD = 9000;
  const MOBILE = window.innerWidth < 768;
  const CROWD_COUNT = MOBILE ? 4000 : CROWD;
  const PIXEL_RATIO = Math.min(window.devicePixelRatio, MOBILE ? 1 : 1.8);

  const wrap    = document.getElementById('copaStadiumWrap');
  const canvas  = document.getElementById('copaStadiumCanvas');
  const loading = document.getElementById('copaStadiumLoading');
  const overlay = document.getElementById('copaStadiumOverlay');
  const audioBtn= document.getElementById('copaAudioBtn');
  if (!wrap || !canvas) return;

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: !MOBILE, alpha: false });
  renderer.setPixelRatio(PIXEL_RATIO);
  renderer.setSize(wrap.clientWidth, wrap.clientHeight);
  renderer.shadowMap.enabled = !MOBILE;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;

  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x04080f);
  scene.fog = new THREE.FogExp2(0x04080f, 0.004);

  const camera = new THREE.PerspectiveCamera(55, wrap.clientWidth / wrap.clientHeight, 0.5, 1200);
  camera.position.set(0, 260, 0);
  camera.lookAt(0, 0, 0);

  const clock = new THREE.Clock();
  let elapsed = 0;
  let phase = 0, phaseTimer = 0;
  let camTheta = 0, camPhi = 20, camRadius = 120;
  let autoRotate = true, isDragging = false;
  let prevX = 0, prevY = 0;

  const ambient = new THREE.AmbientLight(0x1a2445, 0.6);
  scene.add(ambient);
  const hemi = new THREE.HemisphereLight(0x2255aa, 0x1a5e20, 0.5);
  scene.add(hemi);

  const floodData = [[72,52,72],[-72,52,72],[72,52,-72],[-72,52,-72]];
  const floods = floodData.map(([x,y,z]) => {
    const light = new THREE.SpotLight(0xfffbee, 2.2, 400, Math.PI/3.8, 0.35, 1.2);
    light.position.set(x, y, z);
    light.target.position.set(0, 0, 0);
    light.castShadow = !MOBILE;
    if (!MOBILE) { light.shadow.mapSize.set(512, 512); light.shadow.bias = -0.001; }
    scene.add(light); scene.add(light.target);
    return light;
  });

  function buildField() {
    const fieldMat = new THREE.MeshStandardMaterial({ color: 0x1a5e1a, roughness: 0.95 });
    const field = new THREE.Mesh(new THREE.PlaneGeometry(FW+4, FL+4), fieldMat);
    field.rotation.x = -Math.PI/2; field.receiveShadow = true; scene.add(field);
    [0x1a5e1a, 0x1e6c1e].forEach((col, p) => {
      const mat = new THREE.MeshStandardMaterial({ color: col, roughness: 0.95 });
      const S=10, sw=FL/S;
      for (let i=p; i<S; i+=2) {
        const m = new THREE.Mesh(new THREE.PlaneGeometry(FW, sw-0.05), mat);
        m.rotation.x = -Math.PI/2; m.position.set(0, 0.01, -FL/2+sw/2+i*sw);
        scene.add(m);
      }
    });
    const LM = new THREE.MeshBasicMaterial({ color: 0xffffff, depthWrite: false });
    const LT=0.35, LY=0.025;
    const line=(w,h,x,z)=>{ const m=new THREE.Mesh(new THREE.PlaneGeometry(w,h),LM); m.rotation.x=-Math.PI/2; m.position.set(x,LY,z); scene.add(m); };
    line(LT,FL,-FW/2,0); line(LT,FL,FW/2,0);
    line(FW,LT,0,-FL/2); line(FW,LT,0,FL/2); line(FW,LT,0,0);
    const circ = new THREE.RingGeometry(9.15, 9.15+LT, 40);
    const cm = new THREE.Mesh(circ, LM); cm.rotation.x=-Math.PI/2; cm.position.y=LY; scene.add(cm);
    const spot = new THREE.Mesh(new THREE.CircleGeometry(0.45,8), LM);
    spot.rotation.x=-Math.PI/2; spot.position.y=LY; scene.add(spot);
    [-1,1].forEach(s=>{
      const gz=s*(FL/2);
      const gMat=new THREE.MeshStandardMaterial({color:0xffffff,roughness:0.4,metalness:0.6});
      const gw=7.32, gh=2.44;
      [-(gw/2),gw/2].forEach(gx=>{
        const post=new THREE.Mesh(new THREE.CylinderGeometry(0.06,0.06,gh,8),gMat);
        post.position.set(gx,gh/2,gz); scene.add(post);
      });
      const bar=new THREE.Mesh(new THREE.CylinderGeometry(0.06,0.06,gw,8),gMat);
      bar.rotation.z=Math.PI/2; bar.position.set(0,gh,gz); scene.add(bar);
    });
    const trackMat=new THREE.MeshStandardMaterial({color:0x5c1818,roughness:0.9});
    const track=new THREE.Mesh(new THREE.PlaneGeometry(FW+MARGIN*2+2,FL+MARGIN*2+2),trackMat);
    track.rotation.x=-Math.PI/2; track.position.y=-0.02; scene.add(track);
  }

  function buildStands() {
    const baseMat=new THREE.MeshStandardMaterial({color:0x2d3748,roughness:0.9});
    const tw=FW+MARGIN*2+ROWS*ROW_D*2+6, tl=FL+MARGIN*2+ROWS*ROW_D*2+6;
    const outerBase=new THREE.Mesh(new THREE.PlaneGeometry(tw,tl),baseMat);
    outerBase.rotation.x=-Math.PI/2; outerBase.position.y=-0.05; scene.add(outerBase);
    function createSide(axis,sign,standLength,isLong){
      const group=new THREE.Group();
      const offset=(isLong?FL:FW)/2+MARGIN;
      for(let r=0;r<ROWS;r++){
        const y=r*ROW_H+ROW_H/2;
        const d=r*ROW_D+ROW_D/2;
        const hue=0.58+(r%3)*0.02;
        const mat=new THREE.MeshStandardMaterial({color:new THREE.Color().setHSL(hue,0.35,0.12+r*0.003),roughness:0.85});
        const geo=new THREE.BoxGeometry(standLength,ROW_H+0.05,ROW_D);
        const mesh=new THREE.Mesh(geo,mat);
        mesh.castShadow=!MOBILE; mesh.receiveShadow=true;
        if(axis==='z') mesh.position.set(0,y,sign*(offset+d));
        else mesh.position.set(sign*(offset+d),y,0);
        group.add(mesh);
      }
      scene.add(group); return group;
    }
    createSide('z',-1,FW+MARGIN*2+ROWS*ROW_D*2,false);
    createSide('z', 1,FW+MARGIN*2+ROWS*ROW_D*2,false);
    createSide('x',-1,FL+MARGIN*2,true);
    createSide('x', 1,FL+MARGIN*2,true);
    const roofH=ROWS*ROW_H+6, roofD=ROWS*ROW_D+MARGIN;
    const roofMat=new THREE.MeshStandardMaterial({color:0x3d4f6a,roughness:0.7,metalness:0.3});
    [[0,FL/2+roofD,FW+roofD*2,3,3],[0,-(FL/2+roofD),FW+roofD*2,3,3],[FW/2+roofD,0,3,3,FL+roofD*2],[-(FW/2+roofD),0,3,3,FL+roofD*2]]
      .forEach(([x,z,rw,rh,rl])=>{ const rm=new THREE.Mesh(new THREE.BoxGeometry(rw||3,rh||3,rl||3),roofMat); rm.position.set(x,roofH,z); scene.add(rm); });
  }

  let crowdMesh, crowdPositions;
  function buildCrowd() {
    const geo=new THREE.SphereGeometry(0.38,MOBILE?3:4,MOBILE?3:4);
    const mat=new THREE.MeshStandardMaterial({roughness:0.8});
    crowdMesh=new THREE.InstancedMesh(geo,mat,CROWD_COUNT);
    crowdPositions=new Float32Array(CROWD_COUNT*3);
    const dummy=new THREE.Object3D();
    const colors=[new THREE.Color(0x2563eb),new THREE.Color(0xdc2626),new THREE.Color(0x15803d),new THREE.Color(0xfbbf24),new THREE.Color(0xffffff),new THREE.Color(0xf97316),new THREE.Color(0x7c3aed)];
    let idx=0;
    const baseOff=FW/2+MARGIN+ROW_D/2, baseOffL=FL/2+MARGIN+ROW_D/2;
    function placeFans(count,fn){
      for(let i=0;i<count&&idx<CROWD_COUNT;i++,idx++){
        const [x,y,z]=fn(i/count);
        crowdPositions[idx*3]=x; crowdPositions[idx*3+1]=y; crowdPositions[idx*3+2]=z;
        dummy.position.set(x,y,z); dummy.rotation.y=Math.random()*Math.PI*2;
        dummy.scale.setScalar(0.8+Math.random()*0.5); dummy.updateMatrix();
        crowdMesh.setMatrixAt(idx,dummy.matrix);
        const col=colors[Math.floor(Math.random()*colors.length)].clone();
        col.offsetHSL(0,0,(Math.random()-0.5)*0.2);
        crowdMesh.setColorAt(idx,col);
      }
    }
    const hc=Math.floor(CROWD_COUNT/4);
    placeFans(hc,t=>{ const r=Math.floor(Math.random()*ROWS),c=Math.floor(t*(FW+ROWS*ROW_D*2)); return[-FW/2-ROWS*ROW_D+c+Math.random()*0.8,r*ROW_H+ROW_H/2+0.4,-(baseOffL+r*ROW_D)]; });
    placeFans(hc,t=>{ const r=Math.floor(Math.random()*ROWS),c=Math.floor(t*(FW+ROWS*ROW_D*2)); return[-FW/2-ROWS*ROW_D+c+Math.random()*0.8,r*ROW_H+ROW_H/2+0.4,baseOffL+r*ROW_D]; });
    placeFans(hc,t=>{ const r=Math.floor(Math.random()*ROWS),c=Math.floor(t*(FL+MARGIN*2)); return[-(baseOff+r*ROW_D),r*ROW_H+ROW_H/2+0.4,-FL/2-MARGIN+c+Math.random()*0.8]; });
    placeFans(CROWD_COUNT-idx,t=>{ const r=Math.floor(Math.random()*ROWS),c=Math.floor(t*(FL+MARGIN*2)); return[baseOff+r*ROW_D,r*ROW_H+ROW_H/2+0.4,-FL/2-MARGIN+c+Math.random()*0.8]; });
    crowdMesh.instanceMatrix.needsUpdate=true;
    if(crowdMesh.instanceColor) crowdMesh.instanceColor.needsUpdate=true;
    scene.add(crowdMesh);
  }

  function updateCrowd(t) {
    if(!crowdMesh) return;
    const dummy=new THREE.Object3D();
    for(let i=0;i<CROWD_COUNT;i++){
      const x=crowdPositions[i*3],y=crowdPositions[i*3+1],z=crowdPositions[i*3+2];
      const wave=Math.sin((x+z)/40+t*1.5);
      const jump=Math.max(0,wave)*1.5;
      dummy.position.set(x,y+jump,z);
      dummy.rotation.y=t*0.5+i*0.01;
      dummy.scale.setScalar(0.8+0.2*Math.max(0,wave));
      dummy.updateMatrix();
      crowdMesh.setMatrixAt(i,dummy.matrix);
    }
    crowdMesh.instanceMatrix.needsUpdate=true;
  }

  let ball;
  function buildBall() {
    const geo=new THREE.SphereGeometry(2.2,32,32);
    const mat=new THREE.MeshStandardMaterial({color:0xffffff,roughness:0.3,metalness:0.05});
    ball=new THREE.Mesh(geo,mat); ball.position.set(0,2.2,0); ball.castShadow=true;
    const markMat=new THREE.MeshBasicMaterial({color:0x111111});
    for(let i=0;i<6;i++){
      const theta=(i/6)*Math.PI*2, phi=Math.PI/4;
      const patch=new THREE.Mesh(new THREE.CircleGeometry(0.6,5),markMat);
      patch.position.set(2.22*Math.sin(phi)*Math.cos(theta),2.22*Math.cos(phi),2.22*Math.sin(phi)*Math.sin(theta));
      patch.lookAt(new THREE.Vector3(patch.position.x*2,patch.position.y*2,patch.position.z*2));
      ball.add(patch);
    }
    const ballLight=new THREE.PointLight(0xfff5cc,0.8,20);
    ball.add(ballLight);
    scene.add(ball);
  }

  let flags=[];
  function buildFlags(){
    [[0xb22234,0xffffff,0x3c3b6e,30,-70],[0xff0000,0xffffff,0x000000,0,-75],[0x006847,0xffffff,0xce1126,-30,-70]].forEach(([c1,c2,c3,x,z])=>{
      const poleH=22;
      const poleMat=new THREE.MeshStandardMaterial({color:0xc0c0c0,metalness:0.8,roughness:0.2});
      const pole=new THREE.Mesh(new THREE.CylinderGeometry(0.15,0.15,poleH,8),poleMat);
      pole.position.set(x,poleH/2,z); scene.add(pole);
      [c1,c2,c3].forEach((col,ci)=>{
        const fMat=new THREE.MeshStandardMaterial({color:col,roughness:0.7,side:THREE.DoubleSide});
        const fGeo=new THREE.PlaneGeometry(8,5/3,8,1);
        const flag=new THREE.Mesh(fGeo,fMat);
        flag.position.set(x+4,poleH-5/2+(ci*5/3),z);
        scene.add(flag);
        flags.push({mesh:flag,phase:ci*0.5});
      });
    });
  }

  function updateFlags(t){
    flags.forEach(({mesh,phase})=>{
      const positions=mesh.geometry.attributes.position;
      for(let i=0;i<positions.count;i++){
        const x=positions.getX(i);
        positions.setZ(i,Math.sin(x*0.8+t*3+phase)*0.4*(x/8+0.1));
      }
      positions.needsUpdate=true;
      mesh.geometry.computeVertexNormals();
    });
  }

  let scoreboardCtx, scoreboardTexture, scoreboardMesh;
  function buildScoreboard(){
    const sbCanvas=document.createElement('canvas');
    sbCanvas.width=512; sbCanvas.height=256;
    scoreboardCtx=sbCanvas.getContext('2d');
    scoreboardTexture=new THREE.CanvasTexture(sbCanvas);
    const geo=new THREE.PlaneGeometry(28,14);
    const mat=new THREE.MeshStandardMaterial({map:scoreboardTexture,roughness:0.6,metalness:0.1,emissive:0x111111});
    scoreboardMesh=new THREE.Mesh(geo,mat);
    scoreboardMesh.position.set(0,ROWS*ROW_H+10,-(FL/2+MARGIN+ROWS*ROW_D+3));
    scene.add(scoreboardMesh);
    const sb2=scoreboardMesh.clone();
    sb2.position.z=-scoreboardMesh.position.z;
    sb2.rotation.y=Math.PI; scene.add(sb2);
  }

  function updateScoreboard(t){
    if(!scoreboardCtx) return;
    const ctx=scoreboardCtx;
    const diff=new Date('2026-06-11T00:00:00-05:00')-Date.now();
    ctx.fillStyle='#040a14'; ctx.fillRect(0,0,512,256);
    ctx.strokeStyle='#fbbf24'; ctx.lineWidth=8; ctx.strokeRect(4,4,504,248);
    ctx.fillStyle='#fbbf24'; ctx.font='bold 32px Arial Black,sans-serif';
    ctx.textAlign='center'; ctx.fillText('COPA 2026 - WORLD CUP',256,55);
    const alpha=0.5+0.5*Math.sin(t*4);
    ctx.strokeStyle=`rgba(37,99,235,${alpha})`; ctx.lineWidth=2;
    ctx.beginPath(); ctx.moveTo(20,70); ctx.lineTo(492,70); ctx.stroke();
    if(diff>0){
      const d=Math.floor(diff/86400000),h=Math.floor((diff%86400000)/3600000);
      const m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
      ctx.fillStyle='#ffffff'; ctx.font='bold 22px Arial,sans-serif';
      ctx.fillText('WORLD CUP KICKS OFF IN',256,100);
      const digits=`${String(d).padStart(3,'0')}:${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      const grad=ctx.createLinearGradient(0,100,512,160);
      grad.addColorStop(0,'#60a5fa'); grad.addColorStop(0.5,'#ffffff'); grad.addColorStop(1,'#ef4444');
      ctx.fillStyle=grad; ctx.font='bold 52px Courier New,monospace';
      ctx.fillText(digits,256,165);
      ctx.fillStyle='#94a3b8'; ctx.font='18px Arial,sans-serif';
      ctx.fillText('DAYS : HRS : MIN : SEC',256,195);
    } else {
      ctx.fillStyle='#00ff88'; ctx.font='bold 40px Arial Black,sans-serif';
      ctx.fillText("IT'S HAPPENING!",256,140);
    }
    const dotAlpha=0.4+0.6*Math.sin(t*6);
    ctx.fillStyle=`rgba(239,68,68,${dotAlpha})`;
    ctx.beginPath(); ctx.arc(30,30,8,0,Math.PI*2); ctx.fill();
    scoreboardTexture.needsUpdate=true;
  }

  function buildLightPoles(){
    const poleMat=new THREE.MeshStandardMaterial({color:0xaabbcc,metalness:0.7,roughness:0.3});
    floodData.forEach(([x,y,z])=>{
      const pole=new THREE.Mesh(new THREE.CylinderGeometry(0.4,0.6,y,8),poleMat);
      pole.position.set(x,y/2,z); scene.add(pole);
      const cluster=new THREE.Mesh(new THREE.BoxGeometry(6,0.8,2),poleMat);
      cluster.position.set(x,y+0.4,z); cluster.lookAt(0,0,0); scene.add(cluster);
      const bulb=new THREE.Mesh(new THREE.SphereGeometry(0.4,8,8),new THREE.MeshBasicMaterial({color:0xfffde7}));
      bulb.position.set(x,y+0.4,z); scene.add(bulb);
    });
  }

  let confettiParticles=[];
  const CONFETTI_COLS=[0x2563eb,0xdc2626,0xfbbf24,0x00ff88,0xffffff,0x7c3aed];
  function launchConfetti(x=0,y=40,z=0,count=80){
    for(let i=0;i<count;i++){
      const geo=new THREE.PlaneGeometry(0.5,0.8);
      const mat=new THREE.MeshBasicMaterial({color:CONFETTI_COLS[Math.floor(Math.random()*CONFETTI_COLS.length)],side:THREE.DoubleSide});
      const mesh=new THREE.Mesh(geo,mat);
      mesh.position.set(x+(Math.random()-0.5)*30,y+Math.random()*20,z+(Math.random()-0.5)*30);
      mesh.rotation.set(Math.random()*Math.PI,Math.random()*Math.PI,Math.random()*Math.PI);
      scene.add(mesh);
      confettiParticles.push({mesh,vx:(Math.random()-0.5)*0.3,vy:-(0.05+Math.random()*0.1),vz:(Math.random()-0.5)*0.3,rx:(Math.random()-0.5)*0.1,ry:(Math.random()-0.5)*0.1,life:1.0,decay:0.005+Math.random()*0.005});
    }
  }
  function updateConfetti(){
    confettiParticles=confettiParticles.filter(p=>{
      p.mesh.position.x+=p.vx; p.mesh.position.y+=p.vy; p.mesh.position.z+=p.vz;
      p.mesh.rotation.x+=p.rx; p.mesh.rotation.y+=p.ry;
      p.life-=p.decay; p.mesh.material.opacity=p.life;
      if(p.life<=0){scene.remove(p.mesh);p.mesh.geometry.dispose();return false;}
      return true;
    });
  }

  function buildAtmosphere(){
    const starGeo=new THREE.BufferGeometry();
    const starPos=new Float32Array(500*3);
    for(let i=0;i<500;i++){
      const theta=Math.random()*Math.PI*2,phi=Math.random()*Math.PI,r=300+Math.random()*200;
      starPos[i*3]=r*Math.sin(phi)*Math.cos(theta);
      starPos[i*3+1]=r*Math.cos(phi);
      starPos[i*3+2]=r*Math.sin(phi)*Math.sin(theta);
    }
    starGeo.setAttribute('position',new THREE.BufferAttribute(starPos,3));
    scene.add(new THREE.Points(starGeo,new THREE.PointsMaterial({color:0xffffff,size:0.8,sizeAttenuation:true})));
  }

  function updateCamera(t,dt){
    phaseTimer+=dt;
    if(phase===0&&phaseTimer>0.5){
      phase=1; phaseTimer=0;
      const txt=document.getElementById('copaStadiumPhase1');
      if(txt) txt.style.opacity='1';
    }
    if(phase===1){
      const prog=Math.min(phaseTimer/4,1);
      const ease=1-Math.pow(1-prog,3);
      camera.position.x=0; camera.position.y=260-235*ease; camera.position.z=100*ease;
      camera.lookAt(0,8,0);
      if(prog>=1){
        phase=2; phaseTimer=0; camRadius=115; camPhi=22; camTheta=0;
        const p1=document.getElementById('copaStadiumPhase1');
        const p2=document.getElementById('copaStadiumPhase2');
        if(p1) p1.style.opacity='0';
        if(p2) p2.style.opacity='1';
        launchConfetti(0,60,0,120);
      }
    }
    if(phase===2&&phaseTimer>3){
      phase=3; phaseTimer=0;
      const p2=document.getElementById('copaStadiumPhase2');
      if(p2) p2.style.opacity='0';
      if(overlay) overlay.style.opacity='1';
      autoRotate=true;
    }
    if(phase>=3){
      if(autoRotate&&!isDragging) camTheta+=0.0015;
      const phi=camPhi*Math.PI/180;
      camera.position.x=camRadius*Math.cos(phi)*Math.sin(camTheta);
      camera.position.y=camRadius*Math.sin(phi);
      camera.position.z=camRadius*Math.cos(phi)*Math.cos(camTheta);
      camera.lookAt(0,8,0);
    }
  }

  function updateLights(t){
    floods.forEach((light,i)=>{
      light.intensity=2.2*(0.95+0.05*Math.sin(t*30+i*2.1));
    });
    const skyProg=Math.min(elapsed/15,1);
    scene.background=new THREE.Color().setHSL(0.62-skyProg*0.12,0.6,0.08+skyProg*0.04);
  }

  function initInteraction(){
    canvas.addEventListener('mousedown',e=>{isDragging=true;autoRotate=false;prevX=e.clientX;prevY=e.clientY;});
    window.addEventListener('mousemove',e=>{
      if(!isDragging||phase<3)return;
      camTheta-=(e.clientX-prevX)*0.005;
      camPhi=Math.max(5,Math.min(60,camPhi-(e.clientY-prevY)*0.3));
      prevX=e.clientX; prevY=e.clientY;
    });
    window.addEventListener('mouseup',()=>{isDragging=false;setTimeout(()=>{if(!isDragging)autoRotate=true;},3000);});
    let lx=0,ly=0,ta=false;
    canvas.addEventListener('touchstart',e=>{ta=true;autoRotate=false;lx=e.touches[0].clientX;ly=e.touches[0].clientY;},{passive:true});
    canvas.addEventListener('touchmove',e=>{
      if(!ta||phase<3)return;
      camTheta-=(e.touches[0].clientX-lx)*0.006;
      camPhi=Math.max(5,Math.min(60,camPhi-(e.touches[0].clientY-ly)*0.2));
      lx=e.touches[0].clientX;ly=e.touches[0].clientY;
    },{passive:true});
    canvas.addEventListener('touchend',()=>{ta=false;setTimeout(()=>{autoRotate=true;},5000);});
    canvas.addEventListener('wheel',e=>{camRadius=Math.max(60,Math.min(200,camRadius+e.deltaY*0.08));},{passive:true});
    window.addEventListener('resize',()=>{
      const w=wrap.clientWidth,h=wrap.clientHeight;
      camera.aspect=w/h; camera.updateProjectionMatrix(); renderer.setSize(w,h);
    });
    document.querySelectorAll('.copa-stadium-cta').forEach(btn=>{
      btn.addEventListener('click',()=>launchConfetti(0,50,0,60));
    });
  }

  let audioCtx=null,isPlaying=false;
  function initAudio(){
    if(!audioBtn)return;
    audioBtn.addEventListener('click',()=>{
      if(!audioCtx){
        audioCtx=new(window.AudioContext||window.webkitAudioContext)();
        const bufSize=audioCtx.sampleRate*3;
        const buf=audioCtx.createBuffer(1,bufSize,audioCtx.sampleRate);
        const data=buf.getChannelData(0);
        for(let i=0;i<bufSize;i++) data[i]=(Math.random()*2-1);
        const src=audioCtx.createBufferSource(); src.buffer=buf; src.loop=true;
        const f1=audioCtx.createBiquadFilter(); f1.type='bandpass'; f1.frequency.value=800; f1.Q.value=0.5;
        const f2=audioCtx.createBiquadFilter(); f2.type='lowpass'; f2.frequency.value=1200;
        const gain=audioCtx.createGain(); gain.gain.value=0.08;
        const lfo=audioCtx.createOscillator(); lfo.frequency.value=0.2;
        const lg=audioCtx.createGain(); lg.gain.value=0.03;
        lfo.connect(lg); lg.connect(gain.gain); lfo.start();
        src.connect(f1); f1.connect(f2); f2.connect(gain); gain.connect(audioCtx.destination); src.start();
        isPlaying=true; audioBtn.textContent='🔊';
      } else if(isPlaying){
        audioCtx.suspend(); isPlaying=false; audioBtn.textContent='🔇';
      } else {
        audioCtx.resume(); isPlaying=true; audioBtn.textContent='🔊';
      }
    });
  }

  buildField(); buildStands(); buildCrowd(); buildBall();
  buildFlags(); buildScoreboard(); buildLightPoles(); buildAtmosphere();
  initInteraction(); initAudio();

  setTimeout(()=>{
    if(loading){loading.style.transition='opacity 1s';loading.style.opacity='0';setTimeout(()=>{loading.style.display='none';},1000);}
  },1200);

  setInterval(()=>{
    if(phase>=3&&Math.random()>0.5) launchConfetti((Math.random()>0.5?1:-1)*40,55,(Math.random()-0.5)*60,40);
  },8000);

  let lastSB=0;
  function animate(){
    requestAnimationFrame(animate);
    const dt=clock.getDelta(); elapsed+=dt;
    updateCamera(elapsed,dt);
    updateLights(elapsed);
    updateCrowd(elapsed);
    if(ball){ball.rotation.x+=0.008;ball.rotation.y+=0.012;ball.position.y=2.2+Math.sin(elapsed*1.2)*0.4;}
    updateFlags(elapsed);
    updateConfetti();
    if(elapsed-lastSB>0.5){updateScoreboard(elapsed);lastSB=elapsed;}
    renderer.render(scene,camera);
  }
  animate();

  window.COPA3D={launchConfetti:(x,y,z,n)=>launchConfetti(x||0,y||50,z||0,n||80),getPhase:()=>phase};
})();